
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { medicalDecListHis } from '@/api/yiliaohuzhu'
export default {
name: 'workspace',
components: {
Tab,
TabItem
},
data () {
return {
areaid: this.$route.params.areaid,
type: this.$route.params.type,
pageSize: 4,
pageCurrent: 1,
list: '',
moremsg: '点击加载更多',
nomore: false
}
},
mounted () {
this.getdeclisthisNow()
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
getdeclisthisNow () {
medicalDecListHis({
accountid: this.accountid,
medicalType: this.type,
area: this.areaid,
pageSize: this.pageSize,
pageCurrent: this.pageCurrent
}).then(res => {
if (res.obj !== null) {
if (res.obj.length > 0) {
this.list = [...this.list, ...res.obj]
this.moremsg = '点击加载更多'
} else {
this.moremsg = ''
this.nomore = true
}
}
})
},
loadmore () {
if (!this.nomore) {
this.moremsg = '正在加载中...'
this.pageCurrent++
this.getdeclisthisNow()
}
}

















}
}
